import { AppConfig } from '../../../common/model/config';
import { ORDER_TYPE_DELIVERY } from '../../../common/model/order-types';
import { allyaTheme } from '../themes/allya.theme';

export const allyaConfig: AppConfig = {
  appName: 'allya',
  appTitle: 'Allya',
  appDescription: 'Peça aqui com a Allya.',
  aggregator: 820,
  takeOutAggregatorId: 21,
  brand: 1330,
  theme: allyaTheme,
  faviconPath: '/favicons/favicon-allya.ico',
  defaultOrderType: ORDER_TYPE_DELIVERY,
  defaultLocation: {
    // Avenida Paulista
    latitude: -23.5631043,
    longitude: -46.6565712,
  },
  featureFlags: {
    removeLogoFromTheApp: true,
    hideAppTitle: true,
    embeddedApplication: true,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: false,
    gmapsAddress: true,
    showOptionsTabsAggregators: true,
    filterByDeliveryArea: true,
    useLocalAggregatorHeaderImg: false,
  },
};
